// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_h5-0";
export var fulfillmentPanelBody = "_h5-1";